/* ===== NEWSLETTER JS ===== */
(function() {
  'use strict';

  var section = document.querySelector('[data-newsletter-section]');
  if (!section) return;

  var form = section.querySelector('#newsletter-form');
  var formWrap = section.querySelector('[data-newsletter-form]');
  var successEl = section.querySelector('[data-newsletter-success]');

  if (form && formWrap && successEl) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value) return;

      // Submit via AJAX
      var formData = new FormData(form);

      fetch('/contact#newsletter-form', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'text/html'
        }
      }).catch(function() {
        // Even if it fails, show success UI
      });

      // Show success
      formWrap.style.display = 'none';
      successEl.style.display = 'block';
    });
  }
})();
